<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.mediaId"
        placeholder="请输入动漫ID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.title"
        placeholder="请输入标题"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.mid"
        placeholder="请输入模块ID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请选择类型"
        clearable
        size="small"
        v-model="params.type"
        @change="getList('status')"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择状态"
        clearable
        size="small"
        v-model="params.status"
        @change="getList('status')"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recommendTag"
        label="标题角标"
        align="center"
        min-width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.recommendTag || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1">每日推荐</el-tag>
          <el-tag type="warning" v-else>单篇推荐</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="mediaType"
        label="媒体类型"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.mediaType == 'video'"
            >动漫</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.mediaType == 'image'"
            >漫画</el-tag
          >
          <el-tag v-else-if="scope.row.mediaType == 'text'">小说</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">开启</el-tag>
          <el-tag v-else>关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mediaId" label="媒体ID" align="center" width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.mediaId || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mid" label="模块ID" align="center" width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.mid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="模块名称"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.module.subModuleName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="titleImg"
        label="标题图片"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.titleImg">暂无标题图片</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.titleImg })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.titleImg"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="peopleImg"
        label="人物图"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.peopleImg">暂无人物图</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.peopleImg })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.peopleImg"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="background"
        label="背景图"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.background">暂无背景图</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.background })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.background"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="tagDetails"
        label="标签"
        align="center"
        width="240"
      >
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tagList" :key="i" class="tagBox">
            <el-tag
              type="success"
              size="mini"
              effect="plain"
              class="tagDetails"
              >{{ "#" + tag.name }}</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" width="380">
        <template slot-scope="scope">
          <span>{{ scope.row.desc || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.startTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.endTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortCode"
        label="排序"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30, 50, 100]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          size="small"
          label="标题:"
          prop="title"
          style="width: 480px"
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="模块" prop="moduleType" style="width: 480px">
          <el-select
            size="small"
            v-model="moduleType"
            placeholder="请选择模块"
            @change="getFilterModules()"
          >
            <el-option
              v-for="item in moduleTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="亚模块" prop="mid" style="width: 480px">
          <el-select
            size="small"
            v-model="form.mid"
            clearable
            placeholder="请选择亚模块"
          >
            <el-option
              v-for="item in filterModuleList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="媒体id:"
          prop="mediaId"
          style="width: 480px"
        >
          <el-input
            :disabled="dialogTitle == '编辑'"
            v-model="form.mediaId"
          ></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="角标:"
          prop="recommendTag"
          style="width: 480px"
        >
          <el-input v-model="form.recommendTag"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="起止时间:"
          prop="recommendTag"
          style="width: 480px"
        >
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="changeTimes"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          size="small"
          label="标题图片:"
          prop="titleImg"
          style="width: 480px"
        >
          <base-upload
            :cover="form.titleImg"
            :action="uploadUrl"
            @successCallback="uploadTitleImg"
            :width="'120px'"
            :height="'120px'"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="人物图:"
            prop="peopleImg"
            style="width: 250px"
          >
            <base-upload
              :cover="form.peopleImg"
              :action="uploadUrl"
              @successCallback="uploadPeopleImg"
              :width="'120px'"
              :height="'120px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
          <el-form-item
            size="small"
            label="背景图:"
            prop="background"
            style="width: 250px"
          >
            <base-upload
              :cover="form.background"
              :action="uploadUrl"
              @successCallback="uploadBackground"
              :width="'120px'"
              :height="'120px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
        </div>
        <el-form-item
          size="small"
          label="类型:"
          prop="type"
          style="width: 480px"
        >
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="状态:"
          prop="status"
          style="width: 480px"
        >
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序:"
          prop="sortCode"
          style="width: 480px"
        >
          <el-input v-model.number="form.sortCode"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="描述:"
          prop="desc"
          style="width: 480px"
        >
          <el-input type="textarea" :rows="4" v-model="form.desc"></el-input>
        </el-form-item>
        <div class="itemBox">
          <el-form-item
            label="标签类型:"
            size="small"
            prop="type"
            style="width: 480px"
          >
            <el-select
              @change="getTagDimensionsList()"
              clearable
              size="small"
              v-model="mediaType"
              placeholder="请选择媒体类型"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in mediaTypes"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="维度:"
            size="small"
            prop="dimension"
            style="width: 480px"
          >
            <el-select
              @change="getTagList"
              v-model="dimension"
              placeholder="请选择维度"
              clearable
            >
              <el-option
                v-for="k in dimensions"
                :key="k.id"
                :label="k.name"
                :value="k.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="标签:" prop="tagObjs">
          <tag-selector
            v-model="tagObjs"
            :tagList="tagList"
            v-if="isTagSelector"
          ></tag-selector>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview" class="imgDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import { changeTime } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import PreviewPicture from "./components/previewPicture";
import TagSelector from "@/components/mediaTagSelector";

export default {
  components: {
    PreviewPicture,
    TagSelector,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      fileList: [], // 用于编辑图片回显
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        mediaId: undefined, // 关联的acg动漫id
        title: undefined, // 标题
        status: undefined, // 状态
        mid: undefined, // 模块id
        type: undefined, // 类型
      },
      rules: {
        mid: [{ required: true, message: "请输入选择亚模块", trigger: "blur" }],
        mediaId: [
          { required: true, message: "请输入选择媒体id", trigger: "blur" },
        ],
        peopleImg: [
          { required: true, message: "请选择人物图片", trigger: "blur" },
        ],
        background: [
          { required: true, message: "请选择背景图", trigger: "blur" },
        ],
      },
      types: [
        {
          label: "每日推荐",
          value: 1,
        },
        {
          label: "单篇推荐",
          value: 2,
        },
      ],
      statuses: [
        {
          label: "关闭",
          value: 0,
        },
        {
          label: "开启",
          value: 1,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      time: "",
      mediaType: undefined, // 媒体类型
      mediaTypes: [
        { label: "动漫", value: 1 },
        { label: "漫画", value: 2 },
      ],
      moduleType: undefined,
      moduleTypes: [
        { label: "漫画", value: 4 },
        //{ label: "动漫", value: 5 },
        //{ label: "小说", value: 6 },
      ],
      moduleList: [], // 所有模块
      filterModuleList: [], // 需要的模块
      dimension: undefined, // 维度
      dimensions: [], // 维度
      tagList: [], //标签列表：包含标签名称和标签id
      tagObjs: [], // 选中的标签
      isTagSelector: false,
      form: {
        id: undefined,
        title: undefined, // 标题
        titleImg: undefined, // 标题图片
        peopleImg: undefined, // 人物图
        background: undefined, // 背景图
        type: 1, // 类型
        sortCode: 0, // 排序
        desc: undefined, // 描述
        mid: undefined, // 模块id
        mediaId: undefined, // 媒体id
        recommendTag: undefined, // 角标
        startTime: undefined, // 开始时间
        endTime: undefined, // 结束时间
        tags: undefined, // 标签id
        status: 0, //状态 0-关闭，1-开启
      },
    };
  },
  created() {
    this.getList();
    this.getAllModules();
  },
  methods: {
    // 标题图片上传成功
    uploadTitleImg(res) {
      this.form.titleImg = res.data.coverImg;
    },
    // 人物图上传成功
    uploadPeopleImg(res) {
      this.form.peopleImg = res.data.coverImg;
    },
    // 背景图上传成功
    uploadBackground(res) {
      this.form.background = res.data.coverImg;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    // 获取所有模块
    getAllModules() {
      API.getModulesAll()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.moduleList = res.data || [];
          } else {
            this.moduleList = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getMediaRecommendList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增推荐
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.background = param.background;
        this.form.desc = param.desc;
        this.form.mediaId = param.mediaId;
        this.form.mid = param.mid;
        this.form.peopleImg = param.peopleImg;
        this.form.recommendTag = param.recommendTag;
        this.form.sortCode = param.sortCode;
        this.form.title = param.title;
        this.form.titleImg = param.titleImg;
        this.form.type = param.type;
        this.form.status = param.status;
        // this.form.tags = param.tags;
        this.tagObjs = param.tagList || [];
        this.isTagSelector = true;
        this.time = [uniteDate(param.startTime), uniteDate(param.endTime)];
        this.moduleType = this.moduleList.filter(
          (item) => item.id == param.mid
        )[0].type;
        this.getFilterModules();
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 获取所需要模块
    getFilterModules() {
      this.filterModuleList = this.moduleList.filter((item) => {
        if (item.type == this.moduleType) {
          return item;
        }
      });
    },
    // 请求种类下的维度列表数据
    getTagDimensionsList() {
      this.tagList = [];
      API.getAnimeAllLatitude({
        type: this.mediaType,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data.list || [];
          } else {
            this.dimensions = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.dimensions = [];
          this.loading = false;
        });
    },
    getTagList() {
      this.tagList = [];
      if (this.mediaType === undefined) {
        this.$message.error("请选择类型");
        return;
      }
      if (this.dimension === undefined || this.dimension === "") {
        this.$message.error("请选择维度");
        return;
      }
      const param = {
        type: this.form.type,
        kind: this.form.kind,
        dimension: this.dimension,
      };
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data || [];
          this.isTagSelector = true;
        }
      });
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var tags = [];
          for (const t of this.tagObjs) {
            tags.push(t.id);
          }
          if (tags.length) {
            this.form.tags = tags;
          }
          API.addMediaRecommend(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var tags = [];
          for (const t of this.tagObjs) {
            tags.push(t.id);
          }
          if (tags.length) {
            this.form.tags = tags;
          }
          API.updateMediaRecommend(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.title}</span>推荐, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            ids: [param.id],
          };
          API.delMediaRecommend(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.background = undefined;
      this.form.desc = undefined;
      this.form.endTime = undefined;
      this.form.mediaId = undefined;
      this.form.mid = undefined;
      this.form.peopleImg = undefined;
      this.form.recommendTag = undefined;
      this.form.sortCode = 0;
      this.form.startTime = undefined;
      this.form.tags = [];
      this.form.title = undefined;
      this.form.titleImg = undefined;
      this.form.status = 0;
      this.form.type = undefined;
      this.time = "";
      this.moduleType = undefined;
      this.mediaType = undefined;
      this.dimension = undefined;
      this.dimensions = [];
      this.tagList = [];
      this.filterModuleList = [];
      this.isTagSelector = false;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 时间触发回调
    changeTimes(time) {
      if (time) {
        this.form.startTime = changeTime(time[0]) || "";
        this.form.endTime = changeTime(time[1]) || "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
.itemBox {
  display: flex;
  // justify-content: space-between;
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
/deep/ .imgDialog .el-dialog {
  background: transparent;
  border: 1px solid white;
}
</style>
